(function() { module.exports = window["Bernie_l10nBundle_vi_VN"]; }());